import axios from "axios";
import Notifications, { error } from "react-notification-system-redux";
import jwtDecode from "jwt-decode";
import { logoutAction } from "../components/login/loginActions";
import { keyLocallyPresentInStorage, showErrorNotification } from "../helpers";
import { refreshToken } from "../services";

/**
 * @function InterceptorService
 * @param props
 * @desc The request interceptor blocks invalid outgoing requests to avoid 403 or 401 errors
 * The response interceptor catches the errors and shows it on UI in the form of notifications
 */

const InterceptorService = props => {
  // Request interceptor
  axios.interceptors.request.use(
    function(config) {
      //Ignore the listed URLs
      let skipUrls = [
        "auth/sign_up",
        "auth/sign_in",
        "auth/verify_user",
        "auth/resend_verification_code",
        "auth/reset_password",
        "auth/verify_reset_password_code",
        "/auth/change_password",
        "users/user_exists",
        "amazonaws.com",
        "/auth/refresh",
        "/_search"
      ];

      for (var i = 0; i < skipUrls.length; i++) {
        if (config.url.indexOf(skipUrls[i]) > -1) {
          return config;
        }
      }

      // Block the requests which do not have Authorization in request headers
      if (config.headers["Authorization"] !== undefined) {
        return config;
      } else {
        return Promise.reject(error);
      }
    },
    function(error) {
      // Catch errors
      return Promise.reject(error);
    }
  );

  /**
   * @function isJwtExpired
   * @desc This function checks if the auth token is valid ot is expired
   */
  function isJwtExpired(errorMsg) {
    const authToken = keyLocallyPresentInStorage("authToken")
      ? localStorage.getItem("authToken")
      : null;

    if (typeof authToken !== "string" || !authToken) {
      showErrorNotification("Invalid token provided");
      return false;
    }

    let isJwtExpired = false;
    const { exp } = jwtDecode(authToken);
    const currentTime = new Date().getTime() / 1000;
    if (currentTime > exp) isJwtExpired = true;

    if (isJwtExpired) handleRefreshToken(errorMsg);
  }

  /**
   * @function handleRefreshToken
   * @desc This function handles refreshing token
   */
  function handleRefreshToken(errorMsg) {
    const params = {
      refresh_token: localStorage.getItem("idt")
    };

    refreshToken(params).then(response => {
      if (response?.data?.success) {
        const responseObj = response.data;
        localStorage.setItem("authToken", `Bearer ${responseObj.auth_token}`);
        localStorage.setItem("idt", responseObj.refresh_token);
        // window.location.reload();
      } else {
        handleLoggingOutUser(errorMsg);
      }
    });
  }

  function handleLoggingOutUser(errorMsg) {
    let notification = {
      title: "Unauthorized!",
      message: "Unauthorized access. Signing out..."
    };
    props.dispatch(Notifications.error(notification));
    props.dispatch(logoutAction);
    return Promise.reject(errorMsg);
  }

  // Response interceptor
  axios.interceptors.response.use(
    function(response) {
      return response;
    },
    function(errorMsg) {
      if (
        // Logout on 401 and 403 errors
        (errorMsg.response && errorMsg.response.status === 401) ||
        (errorMsg.response && errorMsg.response.status === 403)
      ) {
        if (
          keyLocallyPresentInStorage("idt") &&
          errorMsg.response &&
          errorMsg.response.status === 401
        ) {
          isJwtExpired(errorMsg);
        } else {
          handleLoggingOutUser(errorMsg);
        }
      } else {
        return Promise.reject(errorMsg);
      }
    }
  );
};
export { InterceptorService };
